export default "__VITE_ASSET__CxET7Ene__"